
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/screen-time",
      function () {
        return require("private-next-pages/android/local/screen-time/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/screen-time"])
      });
    }
  